import createStore from './create-store';

export default createStore();
